export default "__VITE_ASSET__421a4194__"